import { instantMeiliSearch } from '@meilisearch/instant-meilisearch';
export * from '@meilisearch/instant-meilisearch';

var PACKAGE_VERSION = '0.4.1';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var concatUserAgents = function (clientAgents) {
    return clientAgents.concat(clientAgents.filter(function (agent) { return agent; }));
};
/**
 * Create a searchClient instance
 */
function createSearchClient(_a) {
    var userAgent = _a.userAgent;
    return function (_a) {
        var url = _a.url, apiKey = _a.apiKey, _b = _a.options, options = _b === void 0 ? { clientAgents: [] } : _b;
        var clientAgents = options.clientAgents || [];
        var searchClient = instantMeiliSearch(url, apiKey, __assign(__assign({}, options), { clientAgents: concatUserAgents(__spreadArray([userAgent], clientAgents, true)) })).searchClient;
        return __assign({}, searchClient);
    };
}

/**
 * Create searchClient instance for autocomplete
 */
var userAgent = "Meilisearch autocomplete-client (v".concat(PACKAGE_VERSION, ")");
var meilisearchAutocompleteClient = createSearchClient({ userAgent: userAgent });

var HIGHLIGHT_PRE_TAG = '__aa-highlight__';
var HIGHLIGHT_POST_TAG = '__/aa-highlight__';
var HITS_PER_PAGE = 5;

function fetchMeilisearchResults(_a) {
    var searchClient = _a.searchClient, queries = _a.queries;
    return searchClient
        .search(queries.map(function (searchParameters) {
        var params = searchParameters.params, headers = __rest(searchParameters, ["params"]);
        return __assign(__assign({}, headers), { params: __assign({ hitsPerPage: HITS_PER_PAGE, highlightPreTag: HIGHLIGHT_PRE_TAG, highlightPostTag: HIGHLIGHT_POST_TAG }, params) });
    }))
        .then(function (response) {
        return response.results;
    });
}

function createRequester(fetcher, requesterId) {
    function execute(fetcherParams) {
        return fetcher({
            searchClient: fetcherParams.searchClient,
            queries: fetcherParams.requests.map(function (x) { return x.query; })
        }).then(function (responses) {
            return responses.map(function (response, index) {
                var _a = fetcherParams.requests[index], sourceId = _a.sourceId, transformResponse = _a.transformResponse;
                return {
                    items: response,
                    sourceId: sourceId,
                    transformResponse: transformResponse
                };
            });
        });
    }
    return function createSpecifiedRequester(requesterParams) {
        return function requester(requestParams) {
            return __assign(__assign({ requesterId: requesterId, execute: execute }, requesterParams), requestParams);
        };
    };
}

var createMeilisearchRequester = createRequester(function (params) { return fetchMeilisearchResults(params); }, 'meilisearch');

/**
 * Retrieves Meilisearch results from multiple indexes.
 */
var getMeilisearchResults = createMeilisearchRequester({
    transformResponse: function (response) { return response.hits; }
});

export { concatUserAgents, createMeilisearchRequester, createRequester, createSearchClient, fetchMeilisearchResults, getMeilisearchResults, meilisearchAutocompleteClient };
